import { Button, Typography } from '@mui/material';
import { FC, useCallback } from 'react';
import { IrrelevantApp } from '../irrelevant-apps-types';
import { setSelectedReleventApp } from '../store-actions/irrelevant-apps-store-actions';

const MakeRelevant: FC<MakeRelevantProps> = ({
  setShowDialog,
  irrelevantApp,
}) => {
  const handleClick = useCallback(() => {
    setShowDialog(true);
    setSelectedReleventApp(irrelevantApp);
  }, [irrelevantApp, setShowDialog]);

  return (
    <Button size='small' onClick={handleClick} variant='text' color='primary'>
      <Typography variant='body2'>Make relevant</Typography>
    </Button>
  );
};

export interface MakeRelevantProps {
  setShowDialog: (value: boolean) => void;
  irrelevantApp: IrrelevantApp;
}

export default MakeRelevant;
